"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsService = void 0;
class PermissionsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * list all group
     * @returns UsersGroupResponse
     * @throws ApiError
     */
    listAllGroups() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/permissions/groups',
        });
    }
    /**
     * create new group
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    newGroup(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/permissions/groups',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * list all users in a group
     * @param groupName
     * @returns UsersGroupResponse
     * @throws ApiError
     */
    listAllUsersInGroups(groupName) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/permissions/groups/{groupName}/users',
            path: {
                'groupName': groupName,
            },
        });
    }
    /**
     * add users to group
     * @param groupName
     * @param authorization
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    addUsersToGroup(groupName, authorization, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/permissions/groups/{groupName}/users',
            path: {
                'groupName': groupName,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * remove users from group
     * @param groupName
     * @param authorization
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    removeUsersFromGroup(groupName, authorization, requestBody) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/permissions/groups/{groupName}/users',
            path: {
                'groupName': groupName,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Check if user id is in group
     * @param groupName
     * @param userId
     * @returns UpdateResponse
     * @throws ApiError
     */
    isUserInGroup(groupName, userId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/permissions/groups/{groupName}/users/{userId}',
            path: {
                'groupName': groupName,
                'userId': userId,
            },
        });
    }
    /**
     * add user by email
     * @param groupName
     * @param authorization
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    addUserToGroupByEmail(groupName, authorization, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/permissions/groups/{groupName}/users/email',
            path: {
                'groupName': groupName,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * remove group
     * @param groupName
     * @returns UpdateResponse
     * @throws ApiError
     */
    removeGroup(groupName) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/permissions/groups/{groupName}/akn',
            path: {
                'groupName': groupName,
            },
        });
    }
}
exports.PermissionsService = PermissionsService;
